import { Modal } from "antd";
import { TipoConsumoEnum } from "core/features/consumo/typings";
import { ConsumoUnidadeMedidaEnum } from "features/consumo/typings";
import { useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import { mapTipoConsumo } from "../";
import SelectUnidadeMedidaConsumo from "../../../../../../../../components/Input/SelectUnidadeMedidaConsumo/index";

interface ModalAlterarUnidadeMedidaProps {
  open: boolean;
  defaultUnidadeMedida: ConsumoUnidadeMedidaEnum;
  onSave: (unidadeMedida: ConsumoUnidadeMedidaEnum) => any;
  tipoConsumoId: TipoConsumoEnum;
  onClose: () => any;
  isLoading?: boolean;
}

export default function ModalAlterarUnidadeMedida({
  open,
  tipoConsumoId,
  defaultUnidadeMedida,
  onSave,
  onClose,
  isLoading,
}: ModalAlterarUnidadeMedidaProps) {
  const [unidadeMedida, setUnidadeMedida] = useState<
    ConsumoUnidadeMedidaEnum | undefined
  >(defaultUnidadeMedida);

  const title = `Alterar unidade de medida para consumo de ${mapTipoConsumo[tipoConsumoId]}`;

  return (
    <Modal
      visible={open}
      width="400px"
      title={title}
      closable={false}
      footer={
        <FooterModal
          showRegisterAnother={false}
          onSubmit={() => onSave(unidadeMedida!)}
          isDisabled={!unidadeMedida || isLoading}
          isLoadingSave={isLoading}
          onClose={onClose}
          buttonCancelarText="Fechar"
          primaryButtonText="Salvar"
        />
      }
    >
      <SelectUnidadeMedidaConsumo
        value={unidadeMedida}
        onChange={setUnidadeMedida}
        filteredOptions={[
          ConsumoUnidadeMedidaEnum.KilowattHora,
          ConsumoUnidadeMedidaEnum.Kilos,
        ]}
      />
    </Modal>
  );
}
